module.exports = __webpack_public_path__ + "static/media/title04.1b13e8fd.webp";